import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faGauge,
  faUserPlus,
  faFileCirclePlus,
  faListCheck,
  faClipboardCheck,
  faCircleCheck,
  faChartBar,
  faMoneyCheckAlt,
  faUserCircle
} from '@fortawesome/free-solid-svg-icons';
import { useSidebar } from './SidebarContext';

const Sidebar = () => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const menuItems = [
    { id: 'dashboard', name: 'Dashboard', icon: faGauge, path: '/dashboard' },
    { id: 'add-student', name: 'Add Student', icon: faUserPlus, path: '/add-student' },
    { id: 'add-section', name: 'Add Questions', icon: faFileCirclePlus, path: '/add' },
    { id: 'add-section', name: 'Add Sections', icon: faFileCirclePlus, path: '/add-section' },
    { id: 'question-manager', name: 'Question Bank', icon: faListCheck, path: '/questions' },
    { id: 'students-registered', name: 'Students Registered', icon: faClipboardCheck, path: '/students-list' },
    { id: 'students-attempted-test', name: 'Students Attempted Test', icon: faCircleCheck, path: '/all-completed-Tests' },
    { id: 'AdminResultPage', name: 'Students Results', icon: faChartBar, path: '/adminresultpage' },
    { id: 'payment', name: 'Payment', icon: faMoneyCheckAlt, path: '/Payment-admin' },
    
  ];

  const handleMenuItemClick = (item) => {
    setActiveMenuItem(item.id);
    navigate(item.path);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const mainItem = menuItems.find(item => item.path === currentPath);
    if (mainItem) {
      setActiveMenuItem(mainItem.id);
    }
  }, [location.pathname]);

  return (
    <div className="sidebar-wrapper">
      {/* Toggle Button */}
        <FontAwesomeIcon icon={faBars} />
      {/* Sidebar */}
      <div className="sidebar" style={{ width: isSidebarOpen ? '250px' : '70px' }}>
        <div className="logo-section">
          <img
            src={isSidebarOpen ? '/images/full-logo.jpeg' : '/images/logo.jpeg'}
            alt="Logo"
            style={{
              height: '32px',
              transition: 'all 0.3s ease',
              objectFit: 'contain'
            }}
          />
        </div>

        <div className="menu-section">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className={`sidebar-menu-item ${activeMenuItem === item.id ? 'active' : ''}`}
              onClick={() => handleMenuItemClick(item)}
            >
              <div className="menu-item-content">
                <FontAwesomeIcon icon={item.icon} />
                {isSidebarOpen && <span>{item.name}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .sidebar-wrapper {
          position: relative;
        }

        .sidebar {
          height: 100vh;
          background: linear-gradient(to right, #F3E8FF, #FEE7EF);
          color: gray;
          position: fixed;
          top: 0;
          left: 0;
          overflow-x: hidden;
          overflow-y: auto;
          transition: width 0.2s ease-in-out;
          z-index: 1000;
        }



        .logo-section {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 60px;
          overflow: hidden;
        }

        .menu-section {
          padding: 16px;
        }

        .sidebar-menu-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 16px;
          border-radius: 30px;
          margin-bottom: 5px;
          cursor: pointer;
          transition: all 0.2s ease;
          color: black;
        }

        .sidebar-menu-item:hover {
          color: #6B21A8;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));
      }

        .sidebar-menu-item.active {
          background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));
          color: #6B21A8;
        }


        .menu-item-content {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .sidebar-toggle {
          position: fixed;
          top: 16px;
          height: 40px;
          width: 40px;
          background: #ffffff;
          border: none;
          border-radius: 30px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          cursor: pointer;
          z-index: 1100;
          transition: left 0.2s ease-in-out;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        @media (max-width: 768px) {
          .sidebar {
            width: 70px !important;
          }

          .sidebar-toggle {
            left: 70px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Sidebar;